import React, { useState, useEffect } from "react";
import { Row, Col, Modal, Form, Button, Spinner } from "react-bootstrap";
import "./companySettingsModals.scss";

const UpdateTextValueModal = ({ 
  show, 
  hideModal,
  handleOnChange,
  title = "",
  inputLabel = "",
  placeholder = "",
  defaultValue = "",
  isLoading = false,
  validateValue = () => true,
}) => {
  const [textValue, setTextValue] = useState("");
  const [error, setError] = useState("");

  const UpdateName = () => {
    const isValid = validateValue(textValue);
    if (!isValid) {
      setError("Invalid value");
      return;
    }
    handleOnChange(textValue)
      ?.then(() => {
        hideModal();
      })
  };
  useEffect(() => {
    if (show) {
      setTextValue(defaultValue);
    } else {
      setTextValue("")
    }
    setError("");
  }, [show]);

  return (
    <Modal
      animation={false}
      // show={true}
      show={show}
      dialogClassName=" company-settings-name-modal"
      className=" "
      aria-labelledby=" company-settings-name-modal"
      centered
      scrollable
      onHide={hideModal}
    >
      <Modal.Header className="text-center">
        <div className="w-100 mb-0 font-bold-14">{title}</div>

        <span className="cursor-pointer" onClick={hideModal}>
          <img src="/images/icons/close.svg" alt="" className="close-icon" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <Row>
          {/* Company Name update*/}
          <Col xs={12}>
            <div className="mt-3">
              <p className="label-heading m-0 mb-1">{inputLabel}</p>
              <Form.Group controlId="formBasicInput">
                <Form.Control
                  className={`${error ? "input-error" : ""}`}
                  as="input"
                  type="text"
                  placeholder={placeholder}
                  value={textValue}
                  onChange={(e) => {
                    setError("");
                    setTextValue(e.target.value);
                  }}
                ></Form.Control>
              </Form.Group>
              {error && <span className="error-text">{error}</span>}
            </div>
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex justify-content-end">
          <Button className="cancel-btn" onClick={hideModal} disabled={isLoading}>
            Cancel
          </Button>
          <Button className="save-btn d-flex align-items-center" onClick={UpdateName} disabled={isLoading}>
            <span>Save</span>
            {isLoading && (
              <Spinner
                animation="border"
                variant="light"
                size="sm"
                className="mx-1"
                style={{
                  width: "12px",
                  height: "12px",
                }}
              />
            )}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateTextValueModal;

